export default "__VITE_ASSET__4K8nDn19__"